import { render, staticRenderFns } from "./helpdialog.vue?vue&type=template&id=7b13b508&scoped=true&"
import script from "./helpdialog.vue?vue&type=script&lang=js&"
export * from "./helpdialog.vue?vue&type=script&lang=js&"
import style0 from "./helpdialog.vue?vue&type=style&index=0&id=7b13b508&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b13b508",
  null
  
)

export default component.exports